<template>
  <div @click="starTagging">
    <span
      ><star-rating
        :increment="starRatingIncrementValue"
        :max-rating="starRatingMaxRatingValue"
        :inactive-color="starRatingInactiveColor"
        :active-color="starRatingActiveColor"
        :star-size="starRatingStarSize"
        :rating="overallRating"
        :read-only="true"
        :show-rating="false"
      >
      </star-rating>
    </span>
    <span class="count__css">{{ overallRating }}/5 ({{ counts }} {{ reviewText }})</span>
  </div>
</template>
<script>
import StarRating from 'vue-star-rating';

//import axios from 'axios'

export default {
  name: 'rfp-rare-star-ratings',
  components: {
    StarRating,
  },
  props: {
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    rating: {
      type: String,
      required: true,
    },
    counts: {
      type: String,
      required: false,
    },
    starRatingsTaging: {
      type: Object,
      required: false,
    },
    reviewText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      overallRating: parseInt(this.rating, 0),
    };
  },
  methods: {
    starTagging() {
      dataLayer.push({
        Ecommerce: this.starRatingsTaging.Ecommerce,
        event: this.starRatingsTaging.event,
        eventAction: this.starRatingsTaging.eventAction,
        eventCategory: this.starRatingsTaging.eventCategory,
        eventLabel: this.starRatingsTaging.eventLabel,
      });
      window.eventBus.$emit('kerastaseRatingsTabEnable');
    },
  },
};
</script>
